import { useUser } from 'react-scale/components/ui/UserContext';
import { useProjectId } from 'react-scale/corp/views/CorpProjectGroupManager/hooks/useProjectId';
import { createSessionContext } from '@scale/compass-ui/hooks/useCompassSessionInit';
import { useMemo } from 'react';

export default function useExternalContext() {
  const user = useUser();
  const projectId = useProjectId();
  return useMemo(() => createSessionContext(user, projectId), [user, projectId]);
}
